import React, { Component } from 'react';
import BonusItem from './BonusItem';

import './Bonuses.less';

class Bonuses extends Component {
  render() {
    const { bonuses } = this.props;

    if (!(bonuses && bonuses.length)) {
      return null;
    }

    return (
      <div>
        <h4>Bonuspercentages</h4>
        <div className="list-group bonuses">
          {bonuses.map(bonus => <BonusItem key={bonus.recId} bonus={bonus} />)}
        </div>
      </div>
    );
  }
}

export default Bonuses;



// WEBPACK FOOTER //
// ./src/contacts/Bonuses.js